export default angular.module('eventix.common.services.stripe',[])
    /**
     * @ngdoc service
     * @name eventix.common.services.StripeSDK
     * @description
     * Loads the Stripe Payments JS SDK
     */
    .factory('StripeSDK', function($window, $q, $interval, LibraryLoader) {
        var stripe;
        return {
            /**
             * @ngdoc method
             * @name eventix.common.services.StripeSDK#get
             * @methodOf eventix.common.services.StripeSDK
             * @description
             * Load and return the initialized Stripe SDK library.
             * If it was already initialized, it'll won't re-init.
             *
             * @param {String} [publicKey] The Stripe PublicKey to initialize, only required on first call
             * @return {Promise<object>} Initialized Stripe SDK
             */
            get: function(publicKey = null) {
                if (stripe)
                    return $q.resolve(stripe);
                else if (!publicKey)
                    return $q.reject('Stripe public key required');
                return LibraryLoader.load('https://js.stripe.com/v3/').then(() => {
                    stripe = $window.Stripe(publicKey); // eslint-disable-line new-cap
                    return stripe;
                });
            }
        };
    }).name;
